import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalIssueNavigatorRedirectRoute: InvariantJiraRoute = {
	name: 'legacy-gin-quicksearch',
	path: '/secure/QuickSearch.jspa',
	query: ['searchString'],
};
